<template>
  <div class="dod-container">
    <div class="title">
      <dod-view-title :title="'Zadania'" />
      <dod-custom-add-button
        :title="'Dodaj zadanie'"
        @click="handleOpenAddTaskModal"
      />
    </div>
    <dod-search-input
      :withFilters="true"
      :filter-settings="[
        'EMPLOYEE_STATUS',
        'CUSTOMER_STATUS',
        'DEPARTMENT',
        'PRIORITY_STATUS',
        'SCOPE_OF_CARE',
        'TASK_CATEGORY',
        'TASK_ASSIGNMENT',
      ]"
      @search="handleSearch"
      @onFilter="handleFilters"
    />
    <div class="categories" v-if="tasks && tasks.data && tasks.data.length > 0">
      <div
        v-for="categoryId of Object.keys(tasksByCategory)"
        :key="categoryId"
        class="category"
      >
        <p class="category-name">
          {{
            (tasksCategories && tasksCategories.data || []).find(
              (taskCategory) => taskCategory.id === categoryId
            ).name
          }}
        </p>
        <div
          class="list"
          v-if="
            tasksByCategory &&
            tasksByCategory[categoryId] &&
            tasksByCategory[categoryId].length > 0
          "
        >
          <task-card
            :task="task"
            v-for="task in tasksByCategory[categoryId]"
            :key="task.id"
            @click="handleTaskCardClick(task)"
          />
        </div>
      </div>
    </div>
    <dod-empty-list v-else />

    <custom-modal
      id="dodAddOrEditTask"
      :title="''"
      :withMenuDots="selectedTask && selectedTask.id"
    >
      <template #title>
        <div
          v-if="
            selectedTask &&
            selectedTask.id &&
            selectedTask.status !== 'FINISHED'
          "
          @click="finishTask"
          class="finish-task-button"
        >
          Oznacz jako zrobione
        </div>
        <div
          v-else-if="selectedTask && selectedTask.id"
          class="task-finished-button"
        >
          Zadanie zakończone
        </div>
      </template>
      <template #content>
        <add-or-edit-task
          :task="selectedTask"
          @updateTask="(e) => updateTask(e)"
          @newTask="(e) => newTask(e)"
          @messageSend="(e) => handleSendMessage(e)"
          @messageDeleted="(e) => handleDeleteMessage(e)"
          @messageEdited="(e) => handleEditMessage(e)"
          :customerUser="
            selectedTask && selectedTask.customer ? selectedTask.customer : null
          "
          :employeeUser="
            selectedTask && selectedTask.employee ? selectedTask.employee : null
          "
        />
      </template>

      <template #menuContent>
        <div class="dots-content" @click="removeTask">
          <img src="../../icons/dod/trash.svg" alt="" />
          <span>Usuń</span>
        </div>
      </template>
    </custom-modal>

    <button
      style="visibility: hidden"
      id="dodAddOrEditTask-open"
      type="button"
      data-toggle="modal"
      data-target="#dodAddOrEditTask"
    />
  </div>
</template>

<script>
import TaskCard from "../../components/dod/TaskCard.vue";
import DodEmptyList from "../../components/dod/DodEmptyList.vue";
import DodSearchInput from "../../components/dod/DodSearchInput.vue";
import DodViewTitle from "../../components/dod/DodViewTitle.vue";
import DodCustomAddButton from "../../components/dod/DodCustomAddButton.vue";
import AddOrEditTask from "../../components/dod/AddOrEditTask.vue";
import CustomModal from "../../components/CustomModal.vue";
export default {
  components: {
    TaskCard,
    DodViewTitle,
    DodSearchInput,
    DodEmptyList,
    DodCustomAddButton,
    AddOrEditTask,
    CustomModal,
  },
  name: "DODTasks",
  data() {
    return {
      searchValue: "",
      selectedTask: null,
      filters: {},
    };
  },

  async mounted() {
    await this.$store.dispatch("getDodTasksCategories");
    await this.$store.dispatch("getDodTasksPriorities");
    await this.$store.dispatch("getDodUsers", {
      search: "",
    });
    await this.$store.dispatch("getDodAdmins");
    await this.fetchTasks(this.searchValue);
  },

  computed: {
    admin() {
      return this.$store.getters.getLoggedAdmin;
    },
    tasks() {
      return this.$store.getters.getDodTasks;
    },
    tasksCategories() {
      return this.$store.getters.getDodTasksCategories;
    },
    tasksByCategory() {
      if (
        this.tasksCategories &&
        this.tasksCategories.data &&
        this.tasks &&
        this.tasks.data
      ) {
        const groupedTasks = {};
        let response = {};
        this.tasksCategories.data.forEach((category) => {
          groupedTasks[category.id] = [];
        });

        this.tasks.data.forEach((task) => {
          const taskCategoryId = task.category.id;
          groupedTasks[taskCategoryId].push(task);
        });

        Object.keys(groupedTasks).forEach((groupedTask) => {
          if (
            groupedTasks[groupedTask] &&
            groupedTasks[groupedTask].length !== 0
          ) {
            response[groupedTask] = groupedTasks[groupedTask];
          }
        });
        return response;
      } else {
        return {};
      }
    },
  },

  watch: {},

  methods: {
    async removeTask() {
      if (
        confirm(
          ` Czy na pewno chcesz usunąć zadanie: ${this.selectedTask.title}?`
        )
      ) {
        this.removeTaskConfirmed();
      }
    },

    async finishTask() {
      if (
        confirm(
          ` Czy na pewno chcesz zakończyć zadanie: ${this.selectedTask.title}?`
        )
      ) {
        this.updateTask({ status: "FINISHED" });
      }
    },

    async removeTaskConfirmed() {
      await this.$store.dispatch("removeDodTask", this.selectedTask.id);
      this.selectedTask = null;
      this.$notify({
        group: "success",
        text: "Zadanie zostało pomyślnie usunięte",
      });
      document.getElementById("dodAddOrEditTask-close").click();
      await this.fetchTasks(this.searchValue);
    },

    async updateTask(data) {
      try {
        await this.$store.dispatch("updateDodTask", {
          taskId: this.selectedTask.id,
          title: data.title || this.selectedTask.title,
          categoryId: data.categoryId || this.selectedTask.category.id,
          priorityId: data.priorityId || this.selectedTask.priority.id,
          admin: data.admin || this.selectedTask.admin,
          dueDate: data.dueDate || this.selectedTask.dueDate,
          status: data.status || this.selectedTask.status,
          customerId: data.customerId || "",
          employeeId: data.employeeId || "",
          description: data.description || this.selectedTask.description || "",
          admins:
            data.admins || this.selectedTask.admins.map((a) => a.admin) || [],
        });
        this.selectedTask = null;
        this.$notify({
          group: "success",
          text: "Zadanie zostało pomyślnie zaktualizowane",
        });
        document.getElementById("dodAddOrEditTask-close").click();
        await this.fetchTasks(this.searchValue);
      } catch (error) {
        if (error.status === 400) {
          this.$notify({
            group: "error",
            text: "Wszystkie pola muszą być uzupełnione",
          });
        } else {
          this.$notify({
            group: "error",
            text: error.data.message,
          });
        }
      }
    },

    async newTask(data) {
      try {
        await this.$store.dispatch("addDodTask", {
          title: data.title || "",
          categoryId: data.categoryId || "",
          priorityId: data.priorityId || "",
          dueDate: data.dueDate || "",
          status: data.status || "ACTIVE",
          customerId: data.customerId || "",
          employeeId: data.employeeId || "",
          description: data.description || "",
          admins: data.admins || [],
        });
        this.selectedTask = null;
        this.$notify({
          group: "success",
          text: "Zadanie zostało dodane",
        });
        document.getElementById("dodAddOrEditTask-close").click();
        await this.fetchTasks(this.searchValue);
      } catch (error) {
        if (error.status === 400) {
          this.$notify({
            group: "error",
            text: "Wszystkie pola muszą być uzupełnione",
          });
        } else {
          this.$notify({
            group: "error",
            text: error.data.message,
          });
        }
      }
    },

    async handleSendMessage(message) {
      try {
        await this.$store.dispatch("addMessage", {
          text: message.text || "",
          admin: this.admin.phone,
          type: "TASK",
          employeeId: message.employeeId || "",
          customerId: message.customerId || "",
          taskId: this.selectedTask.id,
          isAction: false,
        });
        // this.$notify({
        //   group: "success",
        //   text: "Wiadomość wysłana",
        // });
        // document.getElementById("dodAddOrEditTask-close").click();
        await this.fetchTasks(this.searchValue);
        this.selectedTask = (this.tasks && this.tasks.data || []).find(
          (elem) => elem.id === this.selectedTask.id
        );
      } catch (error) {
        if (error.status === 400) {
          this.$notify({
            group: "error",
            text: "Wiadomość nie może być pusta",
          });
        } else {
          this.$notify({
            group: "error",
            text: error.data.message,
          });
        }
      }
    },

    async handleDeleteMessage(messageId) {
      try {
        await this.$store.dispatch("deleteMessage", messageId);
        await this.fetchTasks(this.searchValue);
        this.selectedTask = (this.tasks && this.tasks.data || []).find(
          (elem) => elem.id === this.selectedTask.id
        );
      } catch (error) {
        this.$notify({
          group: "error",
          text: "Nie udało się usunąć wiadomości",
        });
      }
    },

    async handleEditMessage(data) {
      try {
        await this.$store.dispatch("editMessage", data);
        await this.fetchTasks(this.searchValue);
        this.selectedTask = (this.tasks && this.tasks.data || []).find(
          (elem) => elem.id === this.selectedTask.id
        );
      } catch (error) {
        this.$notify({
          group: "error",
          text: "Nie udało się edytować wiadomości",
        });
      }
    },

    async handleSearch(searchValue) {
      this.searchValue = searchValue;
      await this.fetchTasks(this.searchValue);
    },

    async handleFilters(filters) {
      this.filters = {};
      if (filters) {
        filters.forEach((filter) => (this.filters[filter.key] = filter.value));
      }

      await this.fetchTasks(this.searchValue, this.filters);
    },

    async fetchTasks(searchValue, filters) {
      await this.$store.dispatch("getDodTasks", {
        search: searchValue,
        filters,
      });
    },

    handleTaskCardClick(task) {
      this.selectedTask = task;
      document.getElementById("dodAddOrEditTask-open").click();
    },
    handleOpenAddTaskModal() {
      this.selectedTask = {};
      document.getElementById("dodAddOrEditTask-open").click();
    },
  },
};
</script>

<style scoped>
.title {
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: space-between;
}
.categories {
  display: flex;
  gap: 1rem;
  padding: 0;
}
.category {
  width: calc(100% * (1 / 4) - 10px - 1px);
}
.list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 0;
}
.category-name {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.dots-content {
  width: 100%;
  display: flex;
  align-items: center;
}
.dots-content img {
  margin-right: 1rem;
}
.finish-task-button {
  display: flex;
  width: 192px;
  height: 35px;
  padding: 8.326px 23.721px 8.674px 19.279px;
  align-items: center;
  border-radius: 25px;
  border: 0.5px solid #0ea754;
  background: rgba(9, 7, 65, 0.05);
  color: #0ea754;
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  cursor: pointer;
  text-align: center;
}
.task-finished-button {
  text-decoration: underline;
  font-weight: bold;
  font-size: 13px;
  padding: 0;
}
</style>
